import React, { Children } from 'react';
import { SubsidiaryHeader } from '../../../components/shared/SubsidiaryHeader';
import { SubsidiaryFooter } from '../../../components/shared/SubsidiaryFooter';
const navigation = [{
  name: 'Home',
  href: '/palace-hotel'
}, {
  name: 'Rooms & Suites',
  href: '/palace-hotel/rooms'
}, {
  name: 'Dining',
  href: '/palace-hotel/dining'
}, {
  name: 'Spa & Wellness',
  href: '#'
}, {
  name: 'Meetings & Events',
  href: '#'
}, {
  name: 'Contact',
  href: '/palace-hotel#contact'
}];
const footerLinks = [{
  title: 'Accommodations',
  items: [{
    name: 'Deluxe Rooms',
    href: '#'
  }, {
    name: 'Executive Suites',
    href: '#'
  }, {
    name: 'Presidential Suite',
    href: '#'
  }, {
    name: 'Special Offers',
    href: '#'
  }]
}, {
  title: 'Experiences',
  items: [{
    name: 'Fine Dining',
    href: '#'
  }, {
    name: 'Spa Treatments',
    href: '#'
  }, {
    name: 'Fitness Center',
    href: '#'
  }, {
    name: 'Events & Weddings',
    href: '#'
  }]
}];
const rooms = [{
  id: 'deluxe',
  name: 'Deluxe Room',
  description: 'Spacious and elegantly appointed rooms featuring premium amenities and stunning city views.',
  image: 'https://images.unsplash.com/photo-1590490360182-c33d57733427?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1974&q=80',
  price: 199,
  amenities: ['King-size bed', 'Marble bathroom', 'High-speed WiFi', 'Smart TV', '24-hour room service', 'Climate control']
}, {
  id: 'executive',
  name: 'Executive Suite',
  description: 'Luxurious suites with separate living areas, offering an elevated experience with exclusive amenities.',
  image: 'https://images.unsplash.com/photo-1582719478250-c89cae4dc85b?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80',
  price: 349,
  amenities: ['King-size bed', 'Separate living area', 'Premium toiletries', 'Complimentary minibar', 'Executive lounge access', 'Priority dining reservations']
}, {
  id: 'presidential',
  name: 'Presidential Suite',
  description: 'The epitome of luxury with panoramic views, multiple bedrooms, and personalized butler service.',
  image: 'https://images.unsplash.com/photo-1631049307264-da0ec9d70304?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80',
  price: 899,
  amenities: ['Master bedroom with king-size bed', 'Additional bedroom', 'Dining room for 8', 'Private butler service', 'Jacuzzi tub', 'Complimentary airport transfer']
}];
export function PalaceHotelRooms() {
  return <div className="flex flex-col min-h-screen" data-id="element-795">
      <SubsidiaryHeader name="Solochus Palace Hotel" color="bg-amber-50 text-amber-900" navigation={navigation} logo="https://uploadthingy.s3.us-west-1.amazonaws.com/iUXecTUoL9PBBs7nqvYwnz/SOLO_hotel.png" data-id="element-796" />
      <main className="flex-grow" data-id="element-797">
        {/* Hero Section */}
        <section className="bg-amber-100 py-16" data-id="element-798">
          <div className="container mx-auto px-4" data-id="element-799">
            <h1 className="text-4xl font-bold text-amber-900 text-center mb-6" data-id="element-800">
              Rooms & Suites
            </h1>
            <p className="text-xl text-amber-800 text-center max-w-2xl mx-auto" data-id="element-801">
              Experience unparalleled comfort and luxury in our meticulously
              designed accommodations.
            </p>
          </div>
        </section>
        {/* Rooms Showcase */}
        <section className="py-16" data-id="element-802">
          <div className="container mx-auto px-4" data-id="element-803">
            <div className="space-y-16" data-id="element-804">
              {rooms.map((room, index) => <div key={room.id} className={`flex flex-col ${index % 2 === 1 ? 'lg:flex-row-reverse' : 'lg:flex-row'} gap-8 items-center`} data-id="element-805">
                  <div className="lg:w-1/2" data-id="element-806">
                    <img src={room.image} alt={room.name} className="w-full h-80 object-cover rounded-lg shadow-md" data-id="element-807" />
                  </div>
                  <div className="lg:w-1/2" data-id="element-808">
                    <h2 className="text-3xl font-bold text-amber-900 mb-4" data-id="element-809">
                      {room.name}
                    </h2>
                    <p className="text-gray-700 mb-6" data-id="element-810">{room.description}</p>
                    <h3 className="text-lg font-semibold text-amber-800 mb-3" data-id="element-811">
                      Room Amenities
                    </h3>
                    <ul className="grid grid-cols-1 md:grid-cols-2 gap-2 mb-6" data-id="element-812">
                      {room.amenities.map((amenity, i) => <li key={i} className="flex items-center" data-id="element-813">
                          <span className="text-amber-600 mr-2" data-id="element-814">✓</span>
                          <span className="text-gray-700" data-id="element-815">{amenity}</span>
                        </li>)}
                    </ul>
                    <div className="flex flex-wrap items-center justify-between" data-id="element-816">
                      <div className="mb-4 md:mb-0" data-id="element-817">
                        <span className="text-3xl font-bold text-amber-800" data-id="element-818">
                          ${room.price}
                        </span>
                        <span className="text-gray-600" data-id="element-819"> / night</span>
                      </div>
                      <a href="#" className="px-6 py-3 bg-amber-600 text-white font-medium rounded-md hover:bg-amber-700 transition-colors" data-id="element-820">
                        Book Now
                      </a>
                    </div>
                  </div>
                </div>)}
            </div>
          </div>
        </section>
        {/* Booking Information */}
        <section className="bg-amber-50 py-16" data-id="element-821">
          <div className="container mx-auto px-4" data-id="element-822">
            <h2 className="text-3xl font-bold text-amber-900 text-center mb-10" data-id="element-823">
              Booking Information
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-824">
              <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-825">
                <div className="text-4xl text-amber-600 mb-4" data-id="element-826">🕒</div>
                <h3 className="text-xl font-bold text-amber-800 mb-2" data-id="element-827">
                  Check-in & Check-out
                </h3>
                <ul className="text-gray-700 space-y-2" data-id="element-828">
                  <li data-id="element-829">
                    <span className="font-medium" data-id="element-830">Check-in:</span> From 3:00 PM
                  </li>
                  <li data-id="element-831">
                    <span className="font-medium" data-id="element-832">Check-out:</span> Until 12:00
                    PM
                  </li>
                  <li data-id="element-833">
                    <span className="font-medium" data-id="element-834">Early check-in:</span> Subject
                    to availability
                  </li>
                  <li data-id="element-835">
                    <span className="font-medium" data-id="element-836">Late check-out:</span>{' '}
                    Available for a fee
                  </li>
                </ul>
              </div>
              <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-837">
                <div className="text-4xl text-amber-600 mb-4" data-id="element-838">📋</div>
                <h3 className="text-xl font-bold text-amber-800 mb-2" data-id="element-839">
                  Policies
                </h3>
                <ul className="text-gray-700 space-y-2" data-id="element-840">
                  <li data-id="element-841">
                    <span className="font-medium" data-id="element-842">Cancellation:</span> 24 hours
                    notice required
                  </li>
                  <li data-id="element-843">
                    <span className="font-medium" data-id="element-844">Children:</span> Welcome
                    (cribs available)
                  </li>
                  <li data-id="element-845">
                    <span className="font-medium" data-id="element-846">Pets:</span> Not permitted
                  </li>
                  <li data-id="element-847">
                    <span className="font-medium" data-id="element-848">Smoking:</span> Non-smoking
                    property
                  </li>
                </ul>
              </div>
              <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-849">
                <div className="text-4xl text-amber-600 mb-4" data-id="element-850">💳</div>
                <h3 className="text-xl font-bold text-amber-800 mb-2" data-id="element-851">
                  Payment Information
                </h3>
                <ul className="text-gray-700 space-y-2" data-id="element-852">
                  <li data-id="element-853">
                    <span className="font-medium" data-id="element-854">Deposit:</span> Credit card
                    required
                  </li>
                  <li data-id="element-855">
                    <span className="font-medium" data-id="element-856">Payment:</span> All major
                    credit cards accepted
                  </li>
                  <li data-id="element-857">
                    <span className="font-medium" data-id="element-858">Currency:</span> Local and
                    major foreign currencies
                  </li>
                  <li data-id="element-859">
                    <span className="font-medium" data-id="element-860">Taxes:</span> 10% VAT and 5%
                    service charge
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </section>
      </main>
      <SubsidiaryFooter name="Solochus Palace Hotel" description="Experience luxury and exceptional service at Lagos' premier hotel destination." color="bg-amber-900" textColor="text-white" links={footerLinks} logo="https://uploadthingy.s3.us-west-1.amazonaws.com/iUXecTUoL9PBBs7nqvYwnz/SOLO_hotel.png" data-id="element-861" />
    </div>;
}